module.exports = __webpack_public_path__ + "img/background.80babb98.jpg";